import styled from "styled-components";

export const ContainerSizeImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
`;
